import { CreateIcon, DeleteIcon } from "../../../assets";

import Box from "@mui/material/Box";
import { CustomButton } from "../../../components";
import { CustomCard } from "../../../components/composedComponents/subscriptions/customCard";
import { IconButton } from "@mui/material";
import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { isObjectEmpty } from "../../../utils";
import { withDialog, withDrawer } from "../../../HOC's";
import { Prompt } from ".";
import AddIdDrawer from "../../../components/cards/addIdentificationCard";
import ViewAllIdType from "./viewAllIdType";

const dynamicPx = { xs: 1.5, md: 1.5 };

function MultipleIdentification(props) {
  const {
    data: idData = [],
    options = [],
    handleSave,
    handleDelete,
    helperText,
    parentID=""
  } = props;

  // Handlers
  const handleCloseDrawer = () => {
    props.drawer.setDrawer({
      open: false,
      component: <></>,
    });
  };

  const handleSaveIdType = (data) => {
    handleCloseDrawer();
    handleSave(data);
  };

  const handleAddEditClick = (editData = null) => {
    debugger;
    props.drawer.setDrawer({
      open: true,
      component: (handleClose) => (
        <AddIdDrawer
          isEdit={!!editData}
          editData={editData ?? {}}
          options={options}
          onSave={handleSaveIdType}
          handleClose={handleClose}
          parentID={`FromAddId${parentID}`}
        />
      ),
    });
  };

  const handldeDeleteClick = (deletedIdType) => {
    props.dialog.setDialog({
      open: true,
      renderContent: (handleClose, handleAccept) => (
        <Prompt
          title={"Delete ID"}
          body={
            <>
              Are you sure, do you want to delete <br /> this ID?
            </>
          }
          handleClose={handleClose}
          handleAccept={handleAccept}
        />
      ),
      positiveButtonProps: {
        hide: true,
      },
      negativeButtonProps: {
        hide: true,
      },
      onAccept: () => handleDelete(deletedIdType),
      sx: {
        Dialog: {
          "&.MuiDialog-paper": {
            borderRadius: "12px",
          },
        },
        DialogContent: {
          "&.MuiDialogContent-root": {
            padding: 0,
          },
        },
      },
    });
  };

  const handleViewAllClick = () => {
    props.drawer.setDrawer({
      open: true,
      component: (handleClose) => (
        <ViewAllIdType
          value={idData}
          handleClose={handleClose}
          handleEditClick={handleAddEditClick}
          handldeDeleteClick={handldeDeleteClick}
          
        />
      ),
    });
  };

  return (
    <>
      <CustomCard
        {...props}
        required={props.required}
        titleSx={{ color: "text.primary", fontWeight: 500 }}
        stackSx={{ px: dynamicPx }}
        title={"ID Details"}
        helperText={helperText}
        parentID={`FromMultipleIdentification${parentID}`}
      >
        <Box
          sx={{
            pb: 1,
            bgcolor: (theme) => alpha(theme.palette.secondary.light, 0.1),
          }}
        >
          {!isObjectEmpty(idData) && !props.isEdit && (
            <Box>
              {Array.isArray(idData) &&
                idData?.length > 0 &&
                idData?.slice(0, 1)?.map((idType, index) => (
                  <Stack
                    gap={0}
                    sx={{
                      borderBottom: 1,
                      borderColor: "grey.border",
                      px: dynamicPx,
                      pt: 1,
                      bgcolor: "common.white",
                    }}
                  >
                    <>
                      <Stack
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ mb: 1 }}
                      >
                        <Stack>
                          <Typography color="textSecondary">
                            {idType?.id_type_name?.label}
                          </Typography>
                          <Typography
                            sx={{
                              color: "text.primary",
                            }}
                          >
                            {idType?.id_type}
                          </Typography>
                        </Stack>
                        <Stack
                          flexDirection="row"
                          alignItems="flex-end"
                          justifyContent="flex-end"
                          // sx={{ mb: 2 }}
                        >
                          <IconButton
                            onClick={() => handleAddEditClick(idType)}
                            id={`editIdType${idType?.id}`}
                          >
                            <CreateIcon fontSize="small" sx={{fontSize: "16px"}} />
                          </IconButton>
                          <IconButton
                            onClick={() => handldeDeleteClick(idType)}
                            id={`deleteIdType${idType?.id}`}
                          >
                            <DeleteIcon fontSize="small" sx={{fontSize: "16px"}} />
                          </IconButton>
                        </Stack>
                      </Stack>
                    </>
                  </Stack>
                ))}
            </Box>
          )}

          <Box sx={{ px: dynamicPx, pt: 1 }}>
            <Stack flexDirection={"row"} justifyContent={"space-between"}>
              <CustomButton
                variant="text"
                color="secondary"
                size="small"
                onClick={() => handleAddEditClick()}
                id={`addIdBtn${parentID}`}
              >
                + Add ID
              </CustomButton>
              {idData?.length > 1 ? (
                <CustomButton
                  variant="text"
                  color="primary"
                  size="small"
                  onClick={handleViewAllClick}
                  id={`viewSavedIdButton${parentID}`}
                >
                  View Saved ID
                </CustomButton>
              ) : (
                <></>
              )}
            </Stack>
          </Box>
        </Box>
      </CustomCard>
    </>
  );
}

export default withDrawer(withDialog(MultipleIdentification));
